import router from './../../router'
import store from './../../store/store'

const state = () => ({
  current_map_view: null, // 1.- params / 2.- Subbottom / 3.- Mosaics / 4.- Bathymetry / 5.- Sonar
})

const mutations = {
  set_current_map_view(state, data){
    state.current_map_view = data
  },
}

const actions = {
  change_current_map_view({ commit }, data) {
    commit("set_current_map_view", data)
    
    if(data != 1 && router.currentRoute.path != '/map')
      router.push({ name: 'Map', params: {selectlayer: data }})
    else if (data != 1 && router.currentRoute.path == '/map'){
      switch(data){
        case 2:
          //store.dispatch('changeMapLayersState', {layer: 'params'})
          break
        case 3:
          store.dispatch('changeMapLayersState', {layer: 'mosaics'})
          break
        case 4:
          store.dispatch('changeMapLayersState', {layer: 'bathymetry'})
          break
        case 5:
          store.dispatch('changeMapLayersState', {layer: 'sonars'})
          break
      }
    }      
    else if (data == 1 && router.currentRoute.path != '/mapparams')
      router.push("/mapparams") 
   
  },
}

const getters = {
  current_map_view: state => state.current_map_view,  
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/ui.js